// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"6656f2ad","453":"e03b39ff","482":"dbb8154c","892":"4e9876f8","971":"b9593a6e"}[chunkId] + ".chunk.js";
};